module.exports = __webpack_public_path__ + "img/lhdb.6634546a.png";